// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//import Swiper from 'swiper/bundle';
//import 'swiper/css/bundle';
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import "@hotwired/turbo-rails"

// JS Global Compulsory
window.jQuery = window.$ = require("jquery")
require('jquery-ui-bundle');
require("jquery-migrate")
window.jQuery.migrateTrace = false
require("bootstrap")
// Popper.js - Tooltip & Popover Positioning Engine used by Bootstrap. Learn more: https://popper.js.org
window.Popper = require('popper.js').default

require("rails").start()
// require("turbolinks").start()
require("@rails/activestorage").start()

// aos
//import AOS from 'aos';

// JS Implementing Plugins

require("jquery-validation")

import ahoy from "ahoy.js"

// JS Front

require("../vendor/front/js/hs.core")
require("../vendor/front/js/hs.validation")

// parallax
require("../vendor/front/vendor/dzsparallaxer/dzsparallaxer")

import "../src/application/js/controllers"
import "../src/application/js"

// CSS
import "../src/application/css/main.scss"
import "jquery-ui-bundle/jquery-ui.css"
import "../../lib/admin/frontend/vendor/keen/src/plugins/flaticon2/flaticon.css"
import "../../lib/admin/frontend/vendor/keen/src/plugins/flaticon/flaticon.css"

// Media
require.context('../src/application/media', true)
